import Vue from 'vue'
import App from '../../vue/components/calendar.vue'

import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

let handleOutsideClick
Vue.directive('closable', {
  bind (el, binding, vnode) {
    handleOutsideClick = (e) => {
      e.stopPropagation()
      const { handler, exclude } = binding.value
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        if (!clickedOnExcludedEl) {
          const excludedEl = vnode.context.$refs[refName]
          clickedOnExcludedEl = excludedEl.contains(e.target)
        }
      })
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        vnode.context[handler]()
      }
    }
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },

  unbind () {
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

document.addEventListener('DOMContentLoaded', () => {
  var element = document.getElementById('calendar-container');
  if (element) {
    const app = new Vue({
      render: h => h(App)
    }).$mount()
    element.appendChild(app.$el);
  }
})
